/**
 * Filters out duplicate items from an array based on a key selector function.
 * @template T The type of items in the array
 * @template K The type of the key used for comparison
 * @param array The array to filter
 * @param keySelector A function that returns the key to use for comparison
 * @returns A new array with duplicates removed, keeping only the first occurrence of each item
 */
export function filterDuplicates<T, K>(array: T[], keySelector: (item: T) => K): T[] {
  return array.filter(
    (item, index, self) => index === self.findIndex((t) => keySelector(t) === keySelector(item))
  )
}
